import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const ContainerBox = styled.div`
	margin: 1rem 0;
	padding: 10px;

	.MuiTableCell-root {
		padding: 16px 6px;
	}
`;

export const Title = styled.h6`
	font-weight: bold;
	color: #000;
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}

	.MuiInputBase-root {
		border: 2px solid #dedede;
	}
`;

export const RowInputsVehicleInformation = styled(RowInputs)`
	grid-template-columns: 1fr 1fr 1fr 1fr;
	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const RowInputsVehicleFilter = styled(RowInputs)`
	grid-template-columns: repeat(5, 1fr);

	@media (max-width: 1100px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const RowRadio = styled.div`
	.MuiPaper-root.MuiTableContainer-root {
		border: none;
		box-shadow: none;
	}
	.MuiTableBody-root {
		gap: 20px;
		display: flex;
		flex-direction: column;
	}
	.MuiTableBody-root > .MuiTableRow-root {
		border: 2px solid #dedede;
		border-radius: 10px;
	}

	@media (max-width: 750px) {
		table {
			min-width: 750px;
		}
	}
`;

export const RowCheckBox = styled.div`
	display: flex;
	flex-wrap: wrap;

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;

export const LabelDamageArea = styled.span`
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	margin: 0;
`;

export const ContainerAutoCompleteVehicle = styled.div`
	margin-bottom: 15px;
`;
